module.exports = __webpack_public_path__ + "media/images/icons/delivery-0aa61990d9662e6dfbcb81d9cdbf24cb.svg";